import React from "react";
import { useAuth } from "@/utils/AuthContext";
import { Button } from "./ui/button";
import { Paperclip } from "lucide-react";

interface FileDownloadButtonProps {
  url: string; // The URL to fetch the file from
  filename: string; // Optional filename for the downloaded file
}

const FileDownloadButton: React.FC<FileDownloadButtonProps> = ({
  url,
  filename,
}) => {
  const { token } = useAuth();
  const handleDownload = async () => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const blob = await response.blob(); // Convert the response to a blob
      const downloadUrl = window.URL.createObjectURL(blob);

      // Create a temporary link to initiate the download
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Clean up the URL object
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Failed to download file:", error);
    }
  };

  return (
    <Button
      onClick={handleDownload}
      variant="secondary"
      size="default"
      className=""
    >
      <Paperclip />
      {filename}
    </Button>
  );
};

export default FileDownloadButton;
